import {
  SPOTIFY_ACCESS_TOKEN_STORAGE_KEY,
  SPOTIFY_USER_ACCESS_TOKEN_STORAGE_KEY,
  SPOTIFY_ACCESS_TOKEN,
  SPOTIFY_USER_ACCESS_TOKEN,
} from '@/bootstrap/types';

import {
  handleErrors,
  calculateRefreshTimeByExpirationsTime,
} from '@/helpers/index';

import SpotifyAuthService from '@/services/api/SpotifyAuthService';

export default {
  state: {
    spotifyAccessToken: SPOTIFY_ACCESS_TOKEN,
    spotifyUserAccessToken: SPOTIFY_USER_ACCESS_TOKEN,
    spotifyAccessTokenExpirationTime: 3300000,
    spotifyUserAccessTokenExpirationTime: 3300000,
  },
  mutations: {
    updateSpotifyAccessToken(state, updatedAccessToken) {
      localStorage.setItem(SPOTIFY_ACCESS_TOKEN_STORAGE_KEY, updatedAccessToken);
      state.spotifyAccessToken = updatedAccessToken;
      window.eventBus.$emit('receivedSpotifyAccessToken');
    },
    updateSpotifyUserAccessToken(state, updatedAccessToken) {
      localStorage.setItem(SPOTIFY_USER_ACCESS_TOKEN_STORAGE_KEY, updatedAccessToken);
      state.spotifyUserAccessToken = updatedAccessToken;
      window.eventBus.$emit('receivedSpotifyUserAccessToken');
    },
    updateSpotifyAccessTokenExpirationTime(state, updatedExpiratoinTime) {
      state.spotifyAccessTokenExpirationTime = updatedExpiratoinTime;
    },
    updateSpotifyUserAccessTokenExpirationTime(state, updatedUserExpiratoinTime) {
      state.spotifyUserAccessTokenExpirationTime = updatedUserExpiratoinTime;
    },
  },
  actions: {
    authorizeSpotifyApp({ commit }) {
      return new Promise((resolve, reject) => {
        SpotifyAuthService.authorizeApp()
          .then(data => {
            commit('updateSpotifyAccessTokenExpirationTime', calculateRefreshTimeByExpirationsTime(data.expires_in));
            commit('updateSpotifyAccessToken', data.access_token);
            resolve(data);
          })
          .catch(error => {
            handleErrors(error);
            reject(error);
          });
      });
    },
    authorizeSpotifyUser({ commit }, { code, redirectUri }) {
      const payload = {
        code,
        redirect_uri: redirectUri,
      };
      return new Promise((resolve, reject) => {
        SpotifyAuthService.authorizeUser(payload)
          .then(data => {
            commit('updateSpotifyUserAccessTokenExpirationTime', calculateRefreshTimeByExpirationsTime(data.expires_in));
            commit('updateSpotifyUserAccessToken', data.access_token);
            resolve(data);
          })
          .catch(error => {
            handleErrors(error);
            reject(error);
          });
      });
    },
    refreshSpotifyUserAccessToken({ commit }, refreshToken) {
      return new Promise((resolve, reject) => {
        SpotifyAuthService.refreshAccessToken({ refresh_token: refreshToken })
          .then(data => {
            commit('updateSpotifyUserAccessTokenExpirationTime', calculateRefreshTimeByExpirationsTime(data.expires_in));
            commit('updateSpotifyUserAccessToken', data.access_token);
            resolve(data);
          })
          .catch(error => {
            handleErrors(error);
            reject(error);
          });
      });
    },
  },
  getters: {
    spotifyAccessToken(state) {
      return state.spotifyAccessToken;
    },
    spotifyUserAccessToken(state) {
      return state.spotifyUserAccessToken;
    },
    spotifyAccessTokenExpirationTime(state) {
      return state.spotifyAccessTokenExpirationTime;
    },
    spotifyUserAccessTokenExpirationTime(state) {
      return state.spotifyUserAccessTokenExpirationTime;
    },
  },
};
